/* eslint-disable */
import './AreaCard.css';

import React, { useEffect, useState } from 'react';
import { fullImagePath, generateClassName } from '../../../b2b-common/helpers';
import useAreasSDGs from '../../../b2b-frameworks/hooks/useAreasSDGs';
import { FwRelated } from '../FwsRelated';
import { Card, CardContent } from '@mui/material';
import StatusTrendFactory from '../status-trend/StatusTrendFactory';
import DatesRangeFactory from '../dates/DatesRangeFactory';
import ProgressFactory from '../progress/ProgressFactory';
import { calculateTimeProgress } from '../helper';
import MoreButton from '../../../b2b-common/MoreButton';
import { MoreVert } from '@mui/icons-material';
import { isEqual } from 'lodash';

const AreaCard = ({ area, selectedPlanAreaDTOs,
    isCardClickable = true,
    moreButtonSettings = null,
    className = null,
    showStatus = true, showTrend = true, showDatesRange = true,
    showCalendarProgress = true, showTargetProgress = true,
    uneligibleAreaList = [],
    onAccess }) => {

    const [cardIsHovered, setCardIsHovered] = useState(false);
    const [currentArea, setCurrentArea] = useState(null);
    const [currentSelectedPlanAreaDTOs, setCurrentSelectedPlanAreaDTOs] = useState([]);
    const [isSelected, setIsSelected] = useState(false);
    const [isUneligible, setIsUneligible] = useState(uneligibleAreaList.some(uneligibleAreaId => uneligibleAreaId === area.areaId));

    useEffect(() => {
        if (!isEqual(area, currentArea)) {
            let clonedArea = { ...area };
            clonedArea.snapshot = {
                ...clonedArea.snapshot || {},
                calendarProgress: calculateTimeProgress(clonedArea.areaStartDate, clonedArea.areaEndDate)
            };
            setCurrentArea(clonedArea);
        }
        if (!isEqual(selectedPlanAreaDTOs, currentSelectedPlanAreaDTOs)) {
            setCurrentSelectedPlanAreaDTOs(selectedPlanAreaDTOs);
        }
        if (selectedPlanAreaDTOs) {
            setIsSelected(selectedPlanAreaDTOs.some(planAreaDTO => planAreaDTO.planUUID === area.plan.planUUID && planAreaDTO.planAreaId === area.areaId));
        }
        if (uneligibleAreaList) {
            setIsUneligible(uneligibleAreaList.some(uneligibleAreaId => uneligibleAreaId === area.areaId));
        }
    }, [area, selectedPlanAreaDTOs, uneligibleAreaList]);

    const { sdgs2030 } = useAreasSDGs([
        {
            planUUID: currentArea ? currentArea.plan?.planUUID : null,
            planAreaId: currentArea ? currentArea.areaId : null
        }
    ]);

    if (!currentArea) {
        return null;
    }

    const handleMouseEnter = () => {
        if (isCardClickable) {
            setCardIsHovered(true);
        }
    };

    const handleMouseLeave = () => {
        if (isCardClickable) {
            setCardIsHovered(false);
        }
    };

    const handleClick = () => {
        if (isCardClickable && onAccess && !isUneligible) {
            onAccess(currentArea);
        }
    };

    return (
        <Card variant='outlined'
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            className={`${generateClassName('area-card-container', '', className)}${cardIsHovered ? ' area-card-ishovered' : ''}${isSelected ? ' area-card-selected' : ''}${isUneligible ? ' area-card-uneligible' : ''}`}
            onClick={handleClick}
        >
            <div className='area-card-image'>
                <img src={fullImagePath(currentArea.imagePath)} alt={currentArea.areaName} />
                <StatusTrendFactory approach='COMBINED'
                    status={currentArea.snapshot?.status} trend={currentArea.snapshot?.trend} className='area-card-status-and-trend'
                    showStatus={showStatus} showTrend={showTrend}
                />
                <FwRelated
                    framework={sdgs2030} className='area-card-sdgs'
                    showLogo={false} iconsSize={24}
                />
                {moreButtonSettings && (
                    <MoreButton icon={moreButtonSettings.icon || <MoreVert />}
                        buttons={moreButtonSettings.buttons.map(button => ({
                            ...button,
                            onClick: () => button.onClick(currentArea)
                        }))}
                        dropPositionAlign={moreButtonSettings.dropPositionAlign || 'right'}
                        rolesAllowed={moreButtonSettings.rolesAllowed || ['ADMIN', 'EDITOR', 'USER']}
                        className={moreButtonSettings.className || 'jb01-more-button'}
                    />
                )}
            </div>
            <CardContent className='area-card-content' >
                <div className='area-card-name'>{currentArea.areaName}</div>
                {showDatesRange && (
                    <DatesRangeFactory datesRangeType='STANDARD'
                        startDate={currentArea.areaStartDate} endDate={currentArea.areaEndDate} className={'area-card-dates-range'}
                    />
                )}
                <ProgressFactory progressApproach='SIMPLE'
                    targetProgress={currentArea.snapshot?.progress}
                    timeProgress={currentArea.snapshot?.calendarProgress}
                    className={'area-card-progress'}
                    showCalendarProgress={showCalendarProgress} showTargetProgress={showTargetProgress}
                />
                <div className='area-card-description'>{currentArea.areaDescription}</div>
            </CardContent>
        </Card>
    )
}

export default AreaCard;